import { translate } from "app/filters/i18nFilter";
import { DefaultFetchService } from "app/services/fetchService";
import type { GetMeteringData, IMeteringRawData, MeteringStateToTitleMap } from "./types";
import { getMeteringState } from "app/components/metering/MeteringState";

const getTranslatedTxt = (message, count, allowedNum) => {
    return translate(message, {
        count: count,
        allowed: allowedNum,
    });
};

export const fetchMeteringData = (endpoint) => {
    const fetchService = DefaultFetchService.getInstance();
    const rawDataPromise = fetchService.get<IMeteringRawData>(endpoint);
    return rawDataPromise;
};

export const getBannerTitleHOF =
    (getMeteringData: GetMeteringData, meteringStateToTitle: MeteringStateToTitleMap) =>
    (data: IMeteringRawData): string | undefined => {
        const meteringData = getMeteringData(data);
        if (!meteringData) {
            return;
        }
        const { allowedHardLimitation, allowedNum, count, isAdmin } = meteringData;

        const meteringState = getMeteringState({
            allowedHardLimitation,
            allowedNum,
            count,
            isAdmin,
        });
        if (!meteringState) {
            return;
        }

        const { textState } = meteringState;
        return getTranslatedTxt(meteringStateToTitle[textState], count, allowedNum);
    };
